import React from 'react';
import 'leaflet/dist/leaflet.css';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import L from 'leaflet';
import { CssBaseline, Typography, Button, ButtonGroup, Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import stockBuildings from '../img/stockbuilding.jpeg'
import Cookies from 'js-cookie';
import { useDate } from './datepicker/DateContext';

const LeafletMap = ({ coordinates }) => {
  const navigate = useNavigate();
  const { selectedDate } = useDate()
  delete L.Icon.Default.prototype._getIconUrl;

  L.Icon.Default.mergeOptions({
    iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
    iconUrl: require('leaflet/dist/images/marker-icon.png'),
    shadowUrl: require('leaflet/dist/images/marker-shadow.png')
  });

  const setCookieAndNavigate = (siteId) => {
    Cookies.remove('site-id');
    navigate(`/projects/${siteId}/ems/profile?dateRange=${selectedDate[0].dateString}`);
  };   

  return (
    <MapContainer center={[52.36637819019195, 4.900525480569689]} zoom={8} style={{ height: '900px', width: 'auto' }}>
      <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'/>
      {coordinates.map((element, index) => {
        let geoCoordMap = element.geoCoord;
        if (geoCoordMap !== undefined) {
          const coordLat = geoCoordMap.lat;
          const coordLng = geoCoordMap.lng;
          const name = element.navName;
          const geoAddress = element.geoAddr;
                      
          return (
            <Marker key={index} position={[coordLat, coordLng]} >
              <Popup>      
                <Box width="300px">
                  <CssBaseline>
                    <img src={element.infSiteImageUri ? element.infSiteImageUri.val : stockBuildings} style={{maxWidth: "100%", borderRadius: "5px"}} alt='buildingImage'/>
                    <Typography variant="h6">Locatie: {name}</Typography>
                    <Typography variant="h6">Adres: {geoAddress}</Typography>
                    <br/>
                    <ButtonGroup variant="contained" style={{marginTop: '10px'}}>
                      <Button style={{backgroundColor:'#f2f0f0', color:'#141414'}} onClick={() => setCookieAndNavigate(element.id.val)}>Energieprofiel bekijken</Button>
                    </ButtonGroup>
                  </CssBaseline>
                </Box>
              </Popup>
            </Marker>
          );
        }
        return null;
      })}
    </MapContainer>
  );
};

export default LeafletMap;
